import { catchError } from "../catchErrors";
import { getSession } from "../helpers";
import { FRONT_OFFICE_URL } from "../settings";

export async function getProvinces(
  country: string,
  withDescriptions: boolean = true
) {
  const session = getSession();
  const url = `${FRONT_OFFICE_URL}Entities/GetProvinces?idCountry=${country}&withDescriptions=${withDescriptions}`;
  try {
    const result = await $.ajax({
      url: url,
      type: "post",
      dataType: "json",
    });
    return result;
  } catch (error) {
    catchError(error);
  }
}

export async function getCitiesByProvince(
  idProvince: number,
  withDescriptions: boolean = true
) {
  const url = `${FRONT_OFFICE_URL}Entities/GetCitiesByProvince?idProvince=${idProvince}&withDescriptions=${withDescriptions}`;
  try {
    const result = await $.ajax({
      url: url,
      type: "post",
      dataType: "json",
    });
    return result;
  } catch (error) {
    catchError(error);
  }
}
